export default class ApiError extends Error {
  status?: number;
  body?: any;
  url?: string;
  method?: string;

  constructor({
    message,
    status,
    body,
    url,
    method,
  }: {
    message: string;
    status?: number;
    body?: any;
    url?: string;
    method?: string;
  }) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
    this.url = url;
    this.method = method;
  }
}
